import {ReactNode} from "react";
import {Link} from "@/shared/ui/Link";

type Props = {
    href: string;
    children: ReactNode;
    external?: boolean;
    className?: string;
};

export const FooterLink = (
    {
        href,
        children,
        external = false,
        className,
    }: Props
) => {
    if (external) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={className}>{children}</a>
        );
    }

    return (
        <Link href={href} className={className}>{children}</Link>
    );
};
